export enum FeedbackType {
  Positive = 'P',
  Negative = 'N',
}
